import "@nextgen-web-framework/core";
import { cloneDeep as s } from "lodash";
import "@commerce-profile-webcomponents/sdk";
const a = {
  Regular: "REGULAR",
  Proxy: "PROXY",
  Go: "GO",
  Gco: "GCO"
}, d = (t, e) => {
  if (t.length === 0)
    return null;
  {
    const n = t.filter((o) => o.actionType === e);
    return n.length === 0 ? null : n;
  }
}, f = (t) => t === a.Proxy, O = (t = []) => t.map((e) => {
  var n, o;
  if ((n = e == null ? void 0 : e.bundleSlots) != null && n.length) {
    const i = s(e);
    return (o = i.bundleSlots) == null || o.forEach((l) => {
      l.entries.forEach((r) => {
        r.quantity = r.baseQuantity ?? r.quantity;
      });
    }), i;
  }
  return e;
});
export {
  d as e,
  f as i,
  O as v
};
//# sourceMappingURL=cartCommonHelpers-81b36861.mjs.map
